var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var NearestTenPatientBirthdays = /** @class */ (function (_super) {
    __extends(NearestTenPatientBirthdays, _super);
    function NearestTenPatientBirthdays() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NearestTenPatientBirthdays.prototype.getPatientName = function () {
        return this.patient_name;
    };
    NearestTenPatientBirthdays.prototype.getPatientId = function () {
        return Number(this.patient_id);
    };
    NearestTenPatientBirthdays.prototype.getNextBirthday = function () {
        return this.dateFormatter(new Date(this.next_birthday), 'DD/MM/YYYY');
    };
    NearestTenPatientBirthdays.prototype.getPatientMobile = function () {
        return this.mobile;
    };
    return NearestTenPatientBirthdays;
}(Model));
export default NearestTenPatientBirthdays;
